import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthStateService } from '../services/auth/auth-state.service';
export class AuthInterceptor implements HttpInterceptor {
    authStateService = inject(AuthStateService);
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const accessToken = this.authStateService.getAccessTokenValue();
        if (accessToken) {
            req = req.clone({
                headers: req.headers.set('Authorization', `Bearer ${accessToken}`),
            });
        }
        return next.handle(req);
    }
}
